import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ApplicationType } from '../models/application-type.enum';
import { FundType } from '../models/fund-type.enum';
import { Prospectus } from '../models/prospectus-shareholder.model';

// This map defines the relation to the page fund type query param to the api call query param
const API_FUND_TYPE_MAP: { [type in FundType]: string } = {
  [FundType.MUTUAL_FUND]: 'MFN',
  [FundType.EXCHANGE_TRADED_FUND]: 'ETF',
}

@Injectable()
export class ProspectusService {

  private cache: Map<String, any[]> = new Map<ApplicationType, any[]>();

  constructor(private http: HttpClient, private router: Router) { }

  getFundsDocuments(applicationId: ApplicationType, fundType: FundType, annuityProduct?: string): Observable<any[]> {
    let cacheKey = applicationId + fundType + annuityProduct;

    if (this.cache.has(cacheKey)) {
      return of(this.cache.get(cacheKey));
    }

    const queryParams: { applicationId?: ApplicationType, fundType?: string, annuityproduct?: string } = {};
    if (applicationId) {
      queryParams.applicationId = applicationId;
    }
    if (fundType && API_FUND_TYPE_MAP[fundType]) {
      queryParams.fundType = API_FUND_TYPE_MAP[fundType];
    }
    if (annuityProduct) {
      queryParams.annuityproduct = annuityProduct;
    }

    return this.http.get<any>(`${environment.apiUrl}/v1/prospectus-documents`, { params: queryParams }).pipe(
      catchError(err => {
        this.router.navigate(['error'], { queryParams: { c: err.status } });
        return null;
      }),
      map((res: any) => {
        return (annuityProduct) ? res : 
        Object.values(res.fundsDocuments).filter((item: any) => item.fundInformation !== null).map((item: any) => {
          if (item.fundInformation) {
            item.fundInformation._cleanLegalName = '';
            if (item.fundInformation.legalName) {
              item.fundInformation._cleanLegalName = item.fundInformation.legalName.replace(/<(sup|sub)>.{1,7}<\/(sup|sub)>/, '');
            }
          }
          return item;
        });
      }),
      tap(res => {
        this.cache.set(cacheKey, res);
      })
    );
  }
  
  getRedirect(securityId: string, documentType: string, applicationId: ApplicationType): string {
    return `${environment.apiUrl}/v1/eproredirect?securityId=${securityId}&documentType=${documentType}&applicationId=${applicationId}`;
  }
}
